import React from "react";
import Cartoon from './Cartoon';

export default ({ cartoons }) => {

  if (!cartoons) return null;

  return (
    <div>
      {cartoons
        .map(({ node }) => (
          <Cartoon key={node.contentful_id} {...{node}} />
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Cartoons.js